export const PRODUCTIVITY_PAGE = 'reports/productivity/PRODUCTIVITY_PAGE'
